var map = {
	"./development/career_data.json": 857,
	"./development/certification_data.json": 949,
	"./development/education_data.json": 345,
	"./development/personal_data.json": 271,
	"./development/project_data.json": 756,
	"./development/skill_data.json": 636,
	"./development/socials_data.json": 899,
	"./production/career_data.json": 499,
	"./production/certification_data.json": 695,
	"./production/education_data.json": 415,
	"./production/personal_data.json": 5,
	"./production/project_data.json": 646,
	"./production/skill_data.json": 390,
	"./production/socials_data.json": 701
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 570;